export class KeyValueResultDto {
    key: any;
    displayText: string;
    isDefault?: boolean;
}
